export const BUSINESS_CODE_MODE = {
    SUCCESS:'SUCCESS', //业务成功
    USERNAME_OR_PASSWORD_FREE_ERROR:'USERNAME_OR_PASSWORD_FREE_ERROR',//用户名或密码错误
    USER_NOT_AUTHORIZED_TO_LOGIN:'USER_NOT_AUTHORIZED_TO_LOGIN', //用户无权登录
}
